const ACTIVE_ATTR = 'data-hd-menu-active';
const COLLECTION_ALIAS_MAP = {
  'new-arrivals': ['all', 'new-arrivals'],
};

const normalizePath = (value) => {
  if (!value || value === '#') return '';

  let url;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return '';
  }

  let path = url.pathname || '/';
  path = path.replace(/\/+$/, '') || '/';

  return path;
};

const handleize = (value) =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const getCollectionHandleFromPath = (path) => {
  const match = String(path || '').match(/^\/collections\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]).replace(/\/+$/, '') : '';
};

const getLinkTitleHandle = (link) => {
  const titleNode = link.querySelector(
    '.menu-list__link-title, .menu-drawer__menu-item-text, .header-actions__utility-label'
  );

  return handleize(titleNode?.textContent || link.textContent);
};

const collectionHandlesMatch = (linkTitleHandle, targetCollectionHandle, currentCollectionHandle) => {
  if (!currentCollectionHandle) return false;
  if (targetCollectionHandle && targetCollectionHandle === currentCollectionHandle) return true;
  if (linkTitleHandle && linkTitleHandle === currentCollectionHandle) return true;

  const aliases = COLLECTION_ALIAS_MAP[linkTitleHandle] || [];
  return aliases.includes(currentCollectionHandle);
};

const isCurrentLink = (link) => {
  const href = link.getAttribute('href');
  const targetPath = normalizePath(href);
  const currentPath = normalizePath(window.location.href);

  if (!targetPath) return false;

  if (targetPath === currentPath) return true;

  const currentCollectionHandle = getCollectionHandleFromPath(currentPath);
  const targetCollectionHandle = getCollectionHandleFromPath(targetPath);
  const linkTitleHandle = getLinkTitleHandle(link);

  return collectionHandlesMatch(linkTitleHandle, targetCollectionHandle, currentCollectionHandle);
};

const setActiveState = (link, active) => {
  const isDesktopMenuLink = link.classList.contains('menu-list__link');
  const isMobileMenuLink = link.classList.contains('menu-list__item');
  const isDrawerMenuLink = link.classList.contains('menu-drawer__menu-item');
  const isUtilityLink = link.classList.contains('header-actions__utility-link');

  link.classList.toggle('is-hd-active', active);

  if (active) {
    link.setAttribute(ACTIVE_ATTR, 'true');
  } else {
    link.removeAttribute(ACTIVE_ATTR);
  }

  if (active) {
    link.setAttribute('aria-current', 'page');
  } else if (link.getAttribute('aria-current') === 'page') {
    link.removeAttribute('aria-current');
  }

  if (isDesktopMenuLink) link.classList.toggle('menu-list__link--active', active);
  if (isMobileMenuLink) link.classList.toggle('menu-list__item--active', active);
  if (isDrawerMenuLink) link.classList.toggle('menu-drawer__menu-item--active', active);
  if (isUtilityLink) link.classList.toggle('is-active', active);

  const parentListItem = link.closest('.menu-list__list-item');
  if (parentListItem) {
    parentListItem.classList.toggle('is-hd-active', active);
  }
};

const refreshHeaderActiveLinks = () => {
  const links = document.querySelectorAll(
    '.menu-list__link[href], .menu-list__item[href], .menu-drawer__menu-item[href], .header-actions__utility-link[href]'
  );

  links.forEach((link) => setActiveState(link, isCurrentLink(link)));

  document.dispatchEvent(new CustomEvent('hd:header-active-links-updated'));
};

const scheduleRefresh = () => {
  window.requestAnimationFrame(refreshHeaderActiveLinks);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
} else {
  scheduleRefresh();
}

window.addEventListener('pageshow', scheduleRefresh);
window.addEventListener('popstate', scheduleRefresh);
document.addEventListener('shopify:section:load', scheduleRefresh);
document.addEventListener('shopify:section:select', scheduleRefresh);
